import type React from "react";
import { createContext } from "react";

import type { IAttachment } from "../types";

export interface IChatContext {
  attachments: IAttachment[];
  setAttachments: React.Dispatch<React.SetStateAction<IAttachment[]>>;
  isDownloading: boolean;
  setIsDownloading: React.Dispatch<React.SetStateAction<boolean>>;
}

const ChatContext = createContext<IChatContext | undefined>(undefined);

export { ChatContext };
